import { Info } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

// A small info icon that reveals an explanatory tooltip on hover/focus. Used to
// explain how a derived value (e.g. Transaction Volume) is calculated, next to
// a field label or a table column header. Multi-line hints render line-by-line
// (`whitespace-pre-line`).
export function InfoHint({
  hint,
  label,
  ariaLabel,
  className,
}: Readonly<{ hint: string; label: string; ariaLabel?: string; className?: string }>) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={ariaLabel ?? `How ${label} is calculated`}
            className={cn('text-muted-foreground/70 hover:text-foreground', className)}
          >
            <Info className="size-3" aria-hidden />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs whitespace-pre-line normal-case">{hint}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
